import React, { useState } from 'react';
import PutawayPickingPerformance from '../components/charts/PutawayPickingPerformance';
import ProductCategoryPie from '../components/charts/ProductCategoryPie';
import StockCategoryPie from '../components/charts/StockCategoryPie';
import StockMovementTop10Table from '../components/charts/StockMovementTop10Table';
import StockMovementLineChart from '../components/charts/StockMovementLineChart';
import InventoryValueCard from '../components/charts/InventoryValueCard';
import ProductMovementChart from '../components/charts/ProductMovementChart';
import Top10StockOutBarChart from '../components/charts/Top10StockOutBarChart';
import Top10StockOutBarChart12Months from '../components/charts/Top10StockOutBarChart12Months';
import StockBalance from '../components/charts/StockBalance';
import StockBalanceBatch from '../components/charts/StockBalanceBatch';

const DashboardInventory = () => {
  const tabs = ['Product_&_Stock', 'Stock_Balance_Summary', 'Stock_Balance_Batch'];

  const monthOptions = [...Array(12)].map((_, i) => {
    const date = new Date();
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    date.setMonth(date.getMonth() - i);

    const value = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`;
    const label = date.toLocaleDateString('id-ID', {
      month: 'long',
      year: 'numeric',
    });

    return { value, label };
  });

  const [activeTab, setActiveTab] = useState('Product_&_Stock');
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0].value);

  return (
    <div className="p-1">
      {/* Tabs */}
      
	  <div className="flex space-x-0 border-b mb-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium ${
              activeTab === tab
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-600'
            }`}
          >
            
			{tab.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
          </button>
        ))}

        {/* Dropdown bulan */}
        {activeTab === 'Overview' && (
          <select
            className="ml-auto border px-3 py-1 rounded text-sm"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {monthOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Overview Tab */}
      {activeTab === 'Product_&_Stock' && (
		
        <div className="bg-white p-4 shadow rounded space-y-4">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <InventoryValueCard />
          </div>

          {/* Charts */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Product per Category (Current)</h2>
              <ProductCategoryPie />
            </div>
			
			<div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Stok per Category (Current)</h2>
              <StockCategoryPie  />
            </div>

			<div className="md:col-span-2 bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Stock In vs Out (Last 12 Months)</h2>
              <ProductMovementChart type="qty" selectedMonth={selectedMonth} />
            </div>

            <div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Top 10 Stock Out (This Month)</h2>
              <Top10StockOutBarChart />
            </div>

            <div className="bg-white p-4 shadow rounded">
              <h2 className="text-base font-semibold mb-2">Top 10 Stock Out (Last 12 Months)</h2>
              <Top10StockOutBarChart12Months />
            </div>
          </div>
        </div>
      )}

      {/* Stock_Balance_Summary */}
      {activeTab === 'Stock_Balance_Summary' && (
        <div className="bg-white p-4 shadow rounded">
          <StockBalance />
        </div>
      )}
	  
      {/* Stock_Balance_Batch */}
      {activeTab === 'Stock_Balance_Batch' && (
        <div className="bg-white p-4 shadow rounded">
          <StockBalanceBatch />
        </div>
      )}	  
    </div>
  );
};

export default DashboardInventory;
